import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import Dropdown from '../../modules/Dropdown';
/**
 * A Select is sugar for <Dropdown selection />.
 * @see Dropdown
 * @see Form
 */

function Select(props) {
  return /*#__PURE__*/React.createElement(Dropdown, _extends({}, props, {
    selection: true
  }));
}
Select.handledProps = ["options"];
Select.Divider = Dropdown.Divider;
Select.Header = Dropdown.Header;
Select.Item = Dropdown.Item;
Select.Menu = Dropdown.Menu;
export default Select;